import { z } from "zod";
import { IssuanceBaseSchema } from "../generated/Issuance";
import { getUserSchema } from "./user";
import { MaterialBaseSchema } from "../generated/Material";
import { GroupBaseSchema } from "../generated/Group";

export const issuanceRowSchema = IssuanceBaseSchema.base.extend({
  Materials: MaterialBaseSchema.rows,
  User: getUserSchema.strip()
});
export const issuanceRowsSchema = z.array(issuanceRowSchema);

export type issuanceRow = z.infer<typeof issuanceRowSchema>;
export type issuanceRows = z.infer<typeof issuanceRowsSchema>;

// 発行の正規化応答(重複排除)。従来の Materials / User(Group込み) ネストを related バケットへ分離し、
// ネスト形(issuanceRow)への復元は util/hydrators/issuanceHydrator の共通ハイドレータが行う。
// キー名は IndexedDB の SetCache 収集キー(PascalCase)に合わせてある。
export const normalizedIssuanceResponseSchema = z.object({
  Issuances: IssuanceBaseSchema.base.array(),
  related: z.object({
    Materials: MaterialBaseSchema.base.array(),
    // User 内の Group ネストも一般規則どおり分離する(Users は group_id 参照のみ)
    Users: getUserSchema.omit({ Group: true }).strip().array(),
    Groups: GroupBaseSchema.base.array(),
  }),
});
export type NormalizedIssuanceResponse = z.infer<typeof normalizedIssuanceResponseSchema>;

export const issuancePutPayloadSchema = z.object({
  material_count: z.number(),
  remarks: z.string().nullable().optional(),
}).strip();
export type issuancePutPayload = z.infer<typeof issuancePutPayloadSchema>;
